import { useAuthStore } from '@/features/auth/authStore'

/**
 * The agency's display currency (ISO-4217), falling back to AUD when the
 * (possibly stale, persisted) session has no currency yet.
 */
export function useCurrency(): string {
  const agency = useAuthStore((s) => s.agency)
  return agency?.currency ?? 'AUD'
}
